export enum PositionTypes {
  Outsourced = 'OUTSOURCED',
  Borrowed = 'BORROWED',
}
